import { fetchSubscriptionItems } from '~/src/features/domru-tv/packages/store/actions/fetchSubscriptionItems';
import { TAppThunkDispatch, TGetState } from '~/src/store';
import { loadSubscriptions } from '~/src/store/actions/vas';

export const fetchSubscriptions = () => {
    return (dispatch: TAppThunkDispatch, getState: TGetState) => {
        const { auth: { isAuth } } = getState();

        isAuth ? dispatch(loadSubscriptions()) : dispatch(fetchSubscriptionItems());
    };
};
